module.exports = __webpack_public_path__ + "img/bookmark.55e2a121.svg";